import React, { Component } from 'react'
import NumberFormat from 'react-number-format'

class SearchProductPrices extends Component {

    // Component will use parent's item collection.  Send the search results back to the parent.
    componentDidMount(){
        this.props.propegateItems(this.props.items)
    }

    // ===================================
    //  HANDLE CHANGES
    // ===================================
    handleKeyPress(event, itemIndex) {
        if (event.key === 'Enter') {
            event.preventDefault()
            this.props.handleItemSave(itemIndex)
        }
    }

    handlePriceChange(name, valueObject, itemIndex, saleIndex, priceType) {
        const { value } = valueObject
        this.props.handleItemChange(name, value, itemIndex, saleIndex, priceType)
    }

    handleCheckboxClick(itemIndex){
        this.props.handleItemTypeChange(itemIndex)
    }

    showButton(id) {
        return <button
            className={'icon-pencil save-item-btn' +
                (!!this.props.parentItems[id].showButton ? ' show-edit-button' : '') +
                (!!this.props.parentItems[id].loading ? ' loading' : '')
            }
            onClick={() => this.props.handleItemSave(id)}
            disabled={this.props.parentItems[id].loading}
        ></button>
    }
    
    // ===================================
    //  RENDER
    // ===================================
    render() {
        const { saleTypes } = this.props
        const { parentItems } = this.props

        return (
            <div>
                {!!parentItems && parentItems.length ? (
                    <table className="product-prices">
                        <tbody>
                            {parentItems.map((item, i) => {
                                return (
                                    <tr className={'product-item' + (!!item.saved ? ' saved' : '')} key={i}>
                                        <td className="item-title">{item.title}</td>
                                        <td className="item-sku">{item.sku}</td>
                                        <td className="">
                                            {!!item.errors && !!item.errors.price &&
                                                <div className="error msg_animate">{item.errors.price}</div>
                                            }
                                            <div className="input-placeholder-wrapper">
                                                <NumberFormat value={item.price} placeholder="0.00" prefix={'$'} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} disabled={!!item.loading}
                                                    onKeyPress={e => this.handleKeyPress(e, i)}
                                                    onValueChange={e => this.handlePriceChange('price', e, i)}
                                                />
                                            </div>
                                        </td>

                                        {/* SHOW ANY POSSIBLE SALE TYPES FOR EACH PRODUCT */}
                                        {saleTypes.map((sale, j) => {
                                            const saleItem = item.prices[sale.type]
                                            const salePrice = !!saleItem ? saleItem.price : ''
                                            
                                            return (
                                                <td key={j}>
                                                    {!!item.errors && !!item.errors[sale.type] &&
                                                        <div className="error msg_animate">{item.errors[sale.type]}</div>
                                                    }
                                                    <div className="input-placeholder-wrapper">
                                                        <NumberFormat value={salePrice} placeholder={`${sale.type} amount`} prefix={item.price_type ? '$' : ''} suffix={!item.price_type ? '%' : ''} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} disabled={!!item.loading}
                                                            onKeyPress={e => this.handleKeyPress(e, i)}
                                                            onValueChange={e => this.handlePriceChange('price', e, i, sale.type, item.price_type)}
                                                        />
                                                    </div>
                                                </td>
                                            )
                                        })}
                                        
                                        <td className="item-price-type">
                                            <label className="tgl">
                                                <input type="checkbox" id="price_type" value="dollar" checked={item.price_type} disabled={!!item.loading}
                                                    onChange={e => this.handleCheckboxClick(i)}
                                                />
                                                <span data-on="$" data-off="%"></span>
                                            </label>
                                        </td>
                                        <td className="save-cell">
                                            {this.showButton(i)}
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                ) : (
                    <div>No Results</div>
                )}
            </div>
        )
    }
}

SearchProductPrices.defaultProps = {
    items: [],
    startPosition: 0,
    clickHandle: null
}

export default SearchProductPrices



// WEBPACK FOOTER //
// ./src/components/search/SearchProductPrices.js